import { render } from "./DexInputText.vue?vue&type=template&id=210f89da&scoped=true&ts=true"
import script from "./DexInputText.vue?vue&type=script&lang=ts"
export * from "./DexInputText.vue?vue&type=script&lang=ts"

import "./DexInputText.vue?vue&type=style&index=0&id=210f89da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210f89da"]])

export default __exports__